var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isViewGA4)?_c('ActionResultGA4',{attrs:{"device":_vm.device,"project":_vm.project,"usage":_vm.usage},on:{"openModalAddKeyword":_vm.openModalAddKeyword}}):_c('ActionResult',{attrs:{"device":_vm.device,"project":_vm.project,"usage":_vm.usage},on:{"openModalAddKeyword":_vm.openModalAddKeyword}})
}
var staticRenderFns = []

export { render, staticRenderFns }